import React, { useState } from "react";
import './css/style.css';
import Header from './components/Header';
import { Route, Routes } from 'react-router-dom';
import Home from './Pages/Home';
import Footer from './components/Footer';
import Categories from './Pages/Categories';
import Products from './Pages/Products';
import Product from './Pages/Product';
import About from './product-page/About';
import Usagearea from './product-page/Usagearea';
import Usage from './product-page/Usage';
import Storage from './product-page/Storage';
import Package from './product-page/Package';
import Lifetime from './product-page/Lifetime';
import Certificates from './Pages/Certificates';
import Our from './Pages/Our';
import Mission from './Pages/Mission';
import Services from './Pages/Services';
import { Blog } from './Pages/Blog';
import { Contact } from './Pages/Contact';
import { useCookies } from "react-cookie";
import Cookie from './img/cookie.svg';
function App() {
  const [open, setopen] = useState(false)
  const [cookies, setCookie] = useCookies(['cookieAccess']);
  var userLang = navigator.language || navigator.userLanguage;
const openhook = () =>{
  setopen(true);
  setCookie("cookieAccess", 1);
  
}
  return (
    <div className="App">
      <Header />
      <div className="container">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/categories" element={<Categories />} />
          <Route path="/services" element={<Services />} />
          <Route path="/categories/:categoriesName" element={<Products />} />
          <Route path='/product/:productName' exact element={<Product/>}>
            <Route path="description" element={<About/>} />
            <Route path='usagearea' element={<Usagearea/>} />
            <Route path='usage' element={<Usage/>} />
            <Route path='storage' element={<Storage/>} />
            <Route path='package' element={<Package/>} />
            <Route path='lifetime' element={<Lifetime/>} />
          </Route>
          <Route path="/certificates" element={<Certificates />} />
          <Route path="/our" element={<Our />} />
          <Route path="/mission" element={<Mission />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        {
        cookies.cookieAccess ===1 ? "" : open === false ? userLang === "tr" ? <div className="cookie-alert">
        <div className="cookie-alert-top">
          <div className="cookie-alert-top-image">
            <img src={Cookie} alt="cookie icon" />
          </div>
          <p>Bu site çerezleri kullanmaktadır.</p>
        </div>
        <div className="cookie-alert-body">
        İnternet sitemizden en verimli şekilde faydalanabilmeniz ve kullanıcı deneyiminizi geliştirebilmek için çerezleri kullanıyoruz.<br/>
        Bu siteye giriş yaparak çerez kullanımını kabul etmiş sayılıyorsunuz.
        </div>
        <div className="cookie-alert-buttons">
          <div className="cookie-alert-button-in" onClick={() => openhook()}>Tamam</div>
        </div>
      </div> : <div className="cookie-alert">
        <div className="cookie-alert-top">
          <div className="cookie-alert-top-image">
            <img src={Cookie} alt="cookie icon" />
          </div>
          <p>Our website uses cookies</p>
        </div>
        <div className="cookie-alert-body">
        To enhance your experience and enable you to make the most of our website, we use cookies.<br/>
         By entering this site, you are considered to have accepted the use of cookies.
        </div>
        <div className="cookie-alert-buttons">
          <div className="cookie-alert-button-in" onClick={() => openhook()}>Ok</div>
        </div>
      </div>  : ""} 
      </div>
      <Footer/>
    </div>
  );
}

export default App;
